<template>
  <header class="navbar sticky-top flex-md-nowrap align-items-center px-3 py-3">
    <span class="fs-6 fw-normal text-white">에피 마음 센터</span>
    <button
      class="navbar-toggler position-absolute end-0 me-3 d-md-none collapsed"
      type="button"
      @click="clickToggler"
    >
      <span>
        <i class="bi bi-list text-white"></i>
      </span>
    </button>
  </header>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "TopMenuForCustomer",
  data() {
    return {
      notiVisible: false,
    };
  },
  methods: {
    clickToggler() {
      this.$root.$emit(EventName.LeftMenuForCustomerOffcanvasOpening);
    },
  },
};
</script>

<style lang="stylus" scoped>
header
  background-color var(--epi-primary)

select
  background-color var(--epi-primary)

  &:focus
    background-color var(--epi-primary) !important
</style>
